import { Routes } from '@angular/router';
import { AuctionsListComponent } from '@auctions/auctions-list/auctions-list.component';
import { AuctionsDetailComponent } from '@auctions/auctions-detail/auctions-detail.component';

export const AuctionsRoutes: Routes = [
  {
    path: '',
    component: AuctionsListComponent,
    data: { titleKey: 'routes.auctions' },
  },
  {
    path: ':auctionId',
    component: AuctionsDetailComponent,
    data: { titleKey: 'routes.auctionDetails' },
  },
];
